import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WholesaleRetailKit } from '@core/store/start-now-app/start-now-app-state-models';
import { isMexEnv } from '@shared/utils/environment-utils';

@Component({
  selector: 'app-wholesale-retail-card',
  templateUrl: './wholesale-retail-card.component.html',
  styleUrls: ['./wholesale-retail-card.component.scss'],
})
export class WholesaleRetailCardComponent {
  @Input()
  wholesaleRetailKit: WholesaleRetailKit;

  @Input()
  isSelected: boolean;

  @Output() selectChange: EventEmitter<WholesaleRetailKit> = new EventEmitter();

  readonly Select: string = $localize`Select`;
  readonly Selected: string = $localize`Selected`;
  readonly WholesaleConsultant: string = $localize`Wholesale Consultant`;

  readonly isMexEnv = isMexEnv;

  onClick(wholesaleRetailKit: WholesaleRetailKit) {
    this.selectChange.emit(wholesaleRetailKit);
  }

  constructor() {}
}
